import { render, staticRenderFns } from "./ForumDiscussion.vue?vue&type=template&id=34079437&scoped=true"
import script from "./ForumDiscussion.vue?vue&type=script&lang=js"
export * from "./ForumDiscussion.vue?vue&type=script&lang=js"
import style0 from "./ForumDiscussion.vue?vue&type=style&index=0&id=34079437&prod&lang=scss&scoped=true"
import style1 from "./ForumDiscussion.vue?vue&type=style&index=1&id=34079437&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34079437",
  null
  
)

export default component.exports